var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArchiveDrawer = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "currentColor",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.5 15h25c.69 0 1.25.56 1.25 1.25v17.5c0 .69-.56 1.25-1.25 1.25h-25c-.69 0-1.25-.56-1.25-1.25v-17.5c0-.69.56-1.25 1.25-1.25M25 25c.69 0 1.25-.56 1.25-1.25V20h-2.5v2.5h-7.5V20h-2.5v3.75c0 .69.56 1.25 1.25 1.25z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10h20v2.5H10zm3.75-5h12.5v2.5h-12.5z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArchiveDrawer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/archive-drawer.4d881735754e48cc6c3e9ca98f114a3c.svg";